import React from 'react';
import { Field } from 'redux-form';
import { useProjectMembersSuggestions } from './hooks/useProjectMembersSuggestions';

import { useAccountSuggestions } from './hooks/useAccountSuggestions';
import { WrappedSuggestionPicker } from '../Contracts/prefabs/MultipleResourcePicker/SuggestionsPickerBase';

const emptyArray = [];
/** contains only accounts */
export const ProjectAddAccountsField = ({
  form,
  placeholder = 'Enter name',
  autoFocus = false,
  loading = false,
  excludedAccounts = emptyArray,
  scrollbarHeight = 0
}) => {
  const {
    suggestedAccounts,
    excludedAccounts: excludedSuggestions,
    query,
    setQuery,
    loading: loadingSuggestions
  } = useAccountSuggestions(excludedAccounts);

  return (
    <Field
      name="accounts"
      component={WrappedSuggestionPicker}
      autoFocus={autoFocus}
      props={{
        form,
        query,
        setQuery,
        suggestions: suggestedAccounts,
        excludedSuggestions,
        placeholder,
        loading: loadingSuggestions || loading,
        allowAddingOfNewSuggestions: false,
        excludedReason: 'Already selected',
        type: 'account',
        primaryKey: 'email_address',
        scrollbarHeight: scrollbarHeight
      }}
    />
  );
};

/** contains accounts and teams as project members */
export const ProjectAddMembersField = ({
  projectId,
  form,
  placeholder = 'Enter a team or account name',
  autoFocus = false,
  loading = false,
  excludedAccounts = emptyArray,
  scrollbarHeight = 0
}) => {
  const {
    allExcluded,
    allSuggestions,
    loading: loadingSuggestions,
    query,
    setQuery
  } = useProjectMembersSuggestions(projectId, excludedAccounts);

  return (
    <Field
      name="accounts"
      autoFocus={autoFocus}
      component={WrappedSuggestionPicker}
      props={{
        form,
        query,
        setQuery,
        suggestions: allSuggestions,
        excludedSuggestions: allExcluded,
        placeholder,
        loading: loading || loadingSuggestions,
        allowAddingOfNewSuggestions: false,
        excludedReason: 'Already selected',
        primaryKey: 'display_name',
        scrollbarHeight: scrollbarHeight
      }}
    />
  );
};
